// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"xJ-z","carouselContainer":"yJ-z"};